/* Cloudwear: doradca rozmiaru „Dobierz rozmiar" (22.10.2026, PL + EN).
   Rozmiar z tabeli (biust/talia/biodra, krok 4 cm; decyduje największy
   obwód, talia ma 1 cm luzu), korygowany tendencją modelu ze zwrotów
   (assets/cw-fit-data.json) i preferencją klientki. Długość: porównanie
   wzrostu klientki ze wzrostem modelki z metapola custom.wymiary.
   Wymiary zostają w localStorage (cw:fit-profile) — kolejne sukienki
   pokazują podpowiedź od razu pod rozmiarami. Teksty: locales/*.json
   (products.product.cw_fit.*), przekazane przez snippet cw-fit-advisor
   jako [data-cw-fit-strings]; [model]/[size]/… podmienia T(). */
(function () {
  if (window.cwFitInit) return;
  window.cwFitInit = true;

  var KEY = 'cw:fit-profile';
  var ORDER = ['XS', 'S', 'M', 'L'];
  var ZONES = ['bust', 'waist', 'hips'];
  var DEFAULT_CHART = {
    XS: { bust: [78, 82], waist: [60, 64], hips: [88, 92] },
    S: { bust: [82, 86], waist: [64, 68], hips: [92, 96] },
    M: { bust: [86, 90], waist: [68, 72], hips: [96, 100] },
    L: { bust: [90, 94], waist: [72, 76], hips: [100, 104] },
  };
  var PREF = { fit: -0.2, std: 0, loose: 0.3 };
  var dataPromise = null;
  var lastTrigger = null;
  var STR = null;

  var T = function (key, vars) {
    if (!STR) {
      var el = document.querySelector('[data-cw-fit-strings]');
      try {
        STR = el ? JSON.parse(el.textContent) : {};
      } catch (e) {
        STR = {};
      }
    }
    var out = STR[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      out = out.split('[' + k + ']').join(vars[k]);
    });
    return out;
  };

  var readProduct = function () {
    var el = document.querySelector('[data-cw-fit-product]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  };
  var sizesOf = function (p) {
    var seen = {};
    return (p.sizes || '').split(';').filter(Boolean).map(function (s) {
      var a = s.split('|');
      return { name: a[0], available: a[1] === 'true' };
    }).filter(function (s) {
      if (seen[s.name]) return false;
      seen[s.name] = true;
      return true;
    });
  };
  var loadData = function (p) {
    if (!dataPromise) {
      dataPromise = fetch(p.dataUrl).then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    return dataPromise;
  };
  var getProfile = function () {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  };
  var saveProfile = function (pr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(pr));
    } catch (e) {}
  };
  var parseWymiary = function (list) {
    var out = {};
    (Array.isArray(list) ? list : []).forEach(function (line) {
      var m;
      line = String(line).trim();
      if ((m = line.match(/^(?:D[łl]ugo[śs][ćc](?: sukienki)?|Dress length|Length):\s*(\d+)/i))) out.length = +m[1];
      if ((m = line.match(/^(?:Wzrost modelki|Model'?s height):\s*(\d+)/i))) out.modelHeight = +m[1];
      if ((m = line.match(/(?:Parametry modelki|Model parameters):\s*([\d-]+)/i))) out.modelParams = m[1];
      if ((m = line.match(/(?:rozmiar|size):?\s*([A-Z]{1,2}(?:\/[A-Z]{1,2})?)(?![a-z])/))) out.modelSize = m[1];
    });
    return out;
  };

  /* korekta strefy: zwroty „za mały/za duży w X" tego modelu */
  var zoneAdj = function (m, zone) {
    if (!m) return { adj: 0, dir: null };
    var s = m[zone + '_small'] || 0;
    var l = m[zone + '_large'] || 0;
    if (s + l >= 6) {
      var r = (l - s) / (s + l);
      if (r <= -0.5) return { adj: 0.35, dir: 'small' };
      if (r >= 0.5) return { adj: -0.25, dir: 'large' };
      return { adj: 0, dir: null };
    }
    var small = (m.bust_small || 0) + (m.waist_small || 0) + (m.hips_small || 0) + (m.other_small || 0);
    var large = (m.bust_large || 0) + (m.waist_large || 0) + (m.hips_large || 0) + (m.other_large || 0);
    if (small + large >= 10) {
      var g = (large - small) / (small + large);
      if (g <= -0.4) return { adj: 0.2, dir: 'small', general: true };
      if (g >= 0.4) return { adj: -0.15, dir: 'large', general: true };
    }
    return { adj: 0, dir: null };
  };

  var recommend = function (pr, p, data) {
    var m = data && data.models ? data.models[p.model] : null;
    var chart = (data && data.chart) || DEFAULT_CHART;
    var zones = [];
    ZONES.forEach(function (z) {
      var v = +pr[z];
      if (!v) return;
      var base = (v - chart.XS[z][0]) / 4;
      var za = zoneAdj(m, z);
      zones.push({ z: z, v: v, base: base, dir: za.dir, general: za.general, val: base + za.adj - (z === 'waist' ? 0.25 : 0) });
    });
    if (!zones.length) return null;
    var drive = zones.reduce(function (a, b) { return b.val > a.val ? b : a; });
    var final = drive.val + (PREF[pr.pref] || 0);
    var list = sizesOf(p);
    var combined = list.some(function (s) { return s.name.indexOf('/') > 0; });
    var idxs = list.map(function (s) { return combined ? ORDER.indexOf(s.name.split('/')[1]) : ORDER.indexOf(s.name); })
      .filter(function (i) { return i >= 0; });
    if (!idxs.length) return null;
    var maxI = Math.max.apply(null, idxs);
    var minI = combined ? 0 : Math.min.apply(null, idxs);
    var i = Math.max(minI, Math.min(maxI, Math.floor(final)));
    var pick = function (k) {
      var want = ORDER[k];
      return list.filter(function (s) { return s.name === want || s.name.split('/').indexOf(want) >= 0; })[0];
    };
    var chosen = pick(i) || list[0];
    var alt = null;
    if (final - Math.floor(final) >= 0.8 && Math.floor(final) + 1 <= maxI) {
      var nxt = pick(Math.floor(final) + 1);
      if (nxt && nxt.name !== chosen.name) alt = nxt;
    }
    var vals = zones.map(function (z) { return Math.floor(z.base); });
    var tableVal = Math.max.apply(null, zones.map(function (z) { return z.base - (z.z === 'waist' ? 0.25 : 0); }));
    var tableSize = pick(Math.max(minI, Math.min(maxI, Math.floor(tableVal)))) || chosen;
    return {
      tableSize: tableSize,
      size: chosen,
      alt: alt,
      tooBig: final >= maxI + 1,
      tooSmall: final < minI - 0.5,
      spread: Math.max.apply(null, vals) - Math.min.apply(null, vals) >= 1,
      drive: drive,
      zones: zones,
      model: m,
    };
  };

  var lengthTip = function (pr, p, m) {
    var w = parseWymiary(p.wymiary);
    var h = +pr.height;
    var tips = [];
    if (!h || !w.modelHeight) return { tips: tips, w: w };
    var diff = w.modelHeight - h;
    var cm = Math.round(Math.abs(diff) * 0.85);
    var maxi = /maxi/i.test(p.length || '');
    if (Math.abs(diff) >= 5) {
      if (maxi) {
        var lv = { mh: w.modelHeight, h: h, cm: cm };
        tips.push(diff > 0
          ? T('r_len_longer', lv) + (cm >= 6 ? ' ' + T('r_heels') : '')
          : T('r_len_shorter', lv));
      } else {
        tips.push(T(diff > 0 ? 'r_hem_lower' : 'r_hem_higher', { cm: cm, mh: w.modelHeight }));
      }
    }
    if (m) {
      var lo = m.too_long || 0;
      var sh = m.too_short || 0;
      if (diff >= 5 && lo >= 5 && lo >= 2 * sh) tips.push(T('r_too_long'));
      if (diff <= -5 && sh >= 5 && sh >= 2 * lo) tips.push(T('r_too_short'));
    }
    return { tips: tips, w: w };
  };

  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };

  var reasonsHtml = function (rec, pr, p) {
    var name = esc(p.model.charAt(0) + p.model.slice(1).toLowerCase());
    var strong = function (x) { return '<strong>' + esc(x) + '</strong>'; };
    var out = [];
    var given = esc(rec.zones.map(function (z) { return T('lbl_' + z.z) + ' ' + z.v + ' cm'; }).join(', '));
    out.push(rec.tooBig
      ? T('r_big', { given: given, size: esc(rec.size.name) })
      : T('r_table', { given: given, size: strong(rec.tableSize.name) }));
    /* charakter modelu ze zwrotów — jedno zdanie */
    var tight = [], roomy = [], general = null;
    rec.zones.forEach(function (z) {
      if (!z.dir) return;
      if (z.general) { general = z.dir; return; }
      (z.dir === 'small' ? tight : roomy).push(T('zone_' + z.z));
    });
    var join = function (arr) { return arr.length > 1 ? arr.slice(0, -1).join(', ') + T('and') + arr[arr.length - 1] : arr[0]; };
    if (tight.length && roomy.length) {
      out.push(T('r_exp', { text: T('r_both', { model: name, tight: join(tight), roomy: join(roomy) }) }));
    } else if (tight.length || roomy.length) {
      out.push(T('r_exp', { text: T(tight.length ? 'r_tight' : 'r_roomy', { model: name, zones: join(tight.length ? tight : roomy) }) }));
    } else if (general) {
      out.push(T('r_exp', { text: T(general === 'small' ? 'r_gen_small' : 'r_gen_large', { model: name }) }));
    }
    var ti = ORDER.indexOf(rec.tableSize.name.split('/')[0]);
    var ci = ORDER.indexOf(rec.size.name.split('/')[0]);
    var dv = { size: strong(rec.size.name), table: esc(rec.tableSize.name), zone: T('zone_' + rec.drive.z) };
    var prefInDecision = false;
    if (rec.size.name !== rec.tableSize.name && !rec.tooBig) {
      var byModel = rec.drive.dir === (ci > ti ? 'small' : 'large');
      prefInDecision = !byModel;
      if (ci > ti) out.push(T(byModel ? 'r_up_model' : 'r_up_pref', dv));
      else out.push(T(byModel ? 'r_down_model' : 'r_down_pref', dv));
    } else if (rec.spread) {
      out.push(T('r_drive', { zone: T('drive_' + rec.drive.z) }));
    }
    if (!rec.model || (rec.model.sold || 0) < 15) out.push(T('r_new'));
    if (!prefInDecision && pr.pref === 'fit') out.push(T('r_pref_fit'));
    if (!prefInDecision && pr.pref === 'loose') out.push(T('r_pref_loose'));
    if (rec.alt) out.push(T('r_alt', { alt: esc(rec.alt.name) }));
    if (rec.tooBig) out.push(T('r_contact') + ' <a href="mailto:info@cloudwear.pl">info@cloudwear.pl</a>');
    if (rec.tooSmall) out.push(T('r_small', { size: esc(rec.size.name) }));
    var lt = lengthTip(pr, p, rec.model);
    lt.tips.forEach(function (t) { out.push(t); });
    if (lt.w.modelHeight && lt.w.modelSize) {
      out.push(T('r_model', {
        info: lt.w.modelHeight + ' cm' + (lt.w.modelParams ? ', ' + esc(lt.w.modelParams) : ''),
        size: esc(lt.w.modelSize),
      }));
    }
    if (!rec.size.available) out.push(T('r_unavail', { size: esc(rec.size.name) }));
    return out.map(function (t) { return '<li>' + t + '</li>'; }).join('');
  };

  var statusOf = function (rec) {
    if (rec.tooBig || rec.tooSmall) return T('status_out');
    if (rec.alt) return T('status_between');
    return T('status_ok');
  };

  var CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';

  /* formularz wymiarów — wspólny dla okna na PDP i strony przewodnika */
  var formInner = function (idp) {
    var field = function (name, label, min, max) {
      return '<label class="cw-fit__field"><span class="cw-fit__flabel">' + label + '</span>' +
        '<span class="cw-fit__input"><input type="number" inputmode="numeric" name="' + name + '" id="' + idp + '-' + name + '" min="' + min + '" max="' + max + '" step="1" autocomplete="off"><em>cm</em></span></label>';
    };
    var pref = function (val, label, checked) {
      return '<label class="cw-fit__chip"><input type="radio" name="pref" value="' + val + '"' + (checked ? ' checked' : '') + '><span>' + label + '</span></label>';
    };
    return '<div class="cw-fit__grid">' +
        field('height', T('height'), 140, 200) +
        field('bust', T('bust'), 70, 130) +
        field('waist', T('waist'), 50, 120) +
        field('hips', T('hips'), 80, 140) +
      '</div>' +
      '<details class="cw-fit__how"><summary>' + T('how') + '</summary><p>' + T('how_html') + '</p></details>' +
      '<fieldset class="cw-fit__pref"><legend>' + T('pref') + '</legend>' +
        pref('fit', T('pref_fit')) + pref('std', T('pref_std'), true) + pref('loose', T('pref_loose')) +
      '</fieldset>' +
      '<p class="cw-fit__error" data-cw-fit-error hidden>' + T('error') + '</p>' +
      '<button type="submit" class="cw-fit__cta">' + T('submit') + '</button>' +
      '<p class="cw-fit__note">' + T('note_form') + '</p>';
  };

  var buildModal = function () {
    var m = document.querySelector('[data-cw-fit-modal]');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'cw-fit__modal';
    m.hidden = true;
    m.setAttribute('data-cw-fit-modal', '');
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'CwFitTitle');
    m.innerHTML =
      '<div class="cw-fit__backdrop" data-cw-fit-close></div>' +
      '<div class="cw-fit__panel">' +
        '<button type="button" class="cw-fit__close" data-cw-fit-close aria-label="' + T('close') + '">' + CLOSE_SVG + '</button>' +
        '<p class="cw-fit__eyebrow">' + T('eyebrow') + '</p>' +
        '<h2 class="cw-fit__title" id="CwFitTitle">' + T('title') + '</h2>' +
        '<form class="cw-fit__form" data-cw-fit-step="form" novalidate>' +
          '<p class="cw-fit__intro" data-cw-fit-intro></p>' + formInner('CwFit') +
        '</form>' +
        '<div class="cw-fit__result" data-cw-fit-step="result" hidden>' +
          '<p class="cw-fit__label" data-cw-fit-for></p>' +
          '<p class="cw-fit__size" data-cw-fit-size></p>' +
          '<p class="cw-fit__status" data-cw-fit-status></p>' +
          '<ul class="cw-fit__reasons" data-cw-fit-reasons></ul>' +
          '<button type="button" class="cw-fit__cta" data-cw-fit-choose></button>' +
          '<button type="button" class="cw-fit__edit" data-cw-fit-edit>' + T('edit') + '</button>' +
          '<p class="cw-fit__note">' + T('note_result') + ' <a href="mailto:info@cloudwear.pl">info@cloudwear.pl</a></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    return m;
  };

  var showStep = function (modal, step) {
    modal.querySelectorAll('[data-cw-fit-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cw-fit-step') !== step;
    });
  };

  var fillForm = function (root, pr) {
    ['height', 'bust', 'waist', 'hips'].forEach(function (k) {
      var inp = root.querySelector('[name="' + k + '"]');
      if (inp) inp.value = pr && pr[k] ? pr[k] : '';
    });
    var pv = (pr && pr.pref) || 'std';
    var r = root.querySelector('[name="pref"][value="' + pv + '"]');
    if (r) r.checked = true;
  };

  /* ── strona przewodnika: rozmiar wg tabeli + modele z innym rozmiarem ── */
  var guideData = function () {
    var el = document.querySelector('[data-cw-fit-guide-data]');
    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  };
  var renderGuide = function (pr) {
    var g = guideData();
    var box = document.querySelector('[data-cw-fit-guide-result]');
    var form = document.querySelector('[data-cw-fit-guide] .cw-fit__form');
    if (!g || !box) return;
    loadData({ dataUrl: g.dataUrl }).then(function (data) {
      var generic = recommend(pr, { model: '', sizes: 'XS|true;S|true;M|true;' }, { chart: data && data.chart, models: {} });
      if (!generic) return;
      var base = generic.size.name;
      var strong = function (x) { return '<strong>' + esc(x) + '</strong>'; };
      var join = function (arr) { return arr.length > 1 ? arr.slice(0, -1).join(', ') + T('and') + arr[arr.length - 1] : arr[0]; };
      var diffs = [];
      (g.models || []).forEach(function (mo) {
        var rec = recommend(pr, { model: mo.model, sizes: mo.sizes }, data);
        if (!rec) return;
        if (rec.size.name === base || rec.size.name.split('/').indexOf(base) >= 0) return;
        var tight = [], roomy = [], general = null;
        rec.zones.forEach(function (z) {
          if (!z.dir) return;
          if (z.general) { general = z.dir; return; }
          (z.dir === 'small' ? tight : roomy).push(T('zone_' + z.z));
        });
        var why = [];
        if (tight.length) why.push(T('g_tight', { zones: join(tight) }));
        if (roomy.length) why.push(T('g_roomy', { zones: join(roomy) }));
        if (!why.length && general) why.push(T(general === 'small' ? 'g_gen_small' : 'g_gen_large'));
        diffs.push({ mo: mo, rec: rec, why: why.join(', ') });
      });
      var given = esc(generic.zones.map(function (z) { return T('lbl_' + z.z) + ' ' + z.v + ' cm'; }).join(', '));
      var html = '<p class="cw-fit__label">' + T('g_your') + '</p>' +
        '<p class="cw-fit__size">' + esc(base) + '</p>' +
        '<p class="cw-fit-guide__basis">' + T('g_basis', { given: given }) + '</p>';
      if (pr.pref === 'fit') html += '<p class="cw-fit-guide__basis">' + T('r_pref_fit') + '</p>';
      if (pr.pref === 'loose') html += '<p class="cw-fit-guide__basis">' + T('r_pref_loose') + '</p>';
      if (generic.alt) html += '<p class="cw-fit-guide__basis">' + T('r_alt', { alt: esc(generic.alt.name) }) + '</p>';
      if (generic.tooBig) html += '<p class="cw-fit-guide__basis">' + T('r_contact') + ' <a href="mailto:info@cloudwear.pl">info@cloudwear.pl</a></p>';
      if (diffs.length) {
        html += '<p class="cw-fit-guide__h">' + T('g_diff_title') + '</p><ul class="cw-fit-guide__list">' +
          diffs.map(function (d) {
            var name = d.mo.model.charAt(0) + d.mo.model.slice(1).toLowerCase();
            return '<li><a class="cw-fit-guide__row" href="' + esc(d.mo.url) + '">' +
              (d.mo.img ? '<img src="' + esc(d.mo.img) + '" alt="" width="56" height="75" loading="lazy">' : '<span class="cw-fit-guide__noimg"></span>') +
              '<span class="cw-fit-guide__name">' + esc(name) + (d.why ? '<em>' + esc(d.why) + '</em>' : '') + '</span>' +
              '<span class="cw-fit-guide__sz">' + esc(d.rec.size.name) + '</span>' +
              '<span class="cw-fit-guide__see">' + T('g_see') + '</span></a></li>';
          }).join('') + '</ul>' +
          '<p class="cw-fit-guide__rest">' + T('g_rest', { size: strong(base) }) + '</p>';
      } else {
        html += '<p class="cw-fit-guide__rest">' + T('g_none', { size: strong(base) }) + '</p>';
      }
      html += '<p class="cw-fit__note">' + T('g_saved') + '</p>' +
        '<button type="button" class="cw-fit__edit" data-cw-fit-guide-edit>' + T('edit') + '</button>';
      box.innerHTML = html;
      box.hidden = false;
      if (form) form.hidden = true;
    });
  };
  var initGuide = function () {
    var holder = document.querySelector('[data-cw-fit-guide-form]');
    if (!holder || holder.children.length) return;
    holder.innerHTML = '<form class="cw-fit__form" novalidate>' + formInner('CwFitG') + '</form>';
    var pr = getProfile();
    if (pr) {
      fillForm(holder, pr);
      renderGuide(pr);
    }
  };

  var renderResult = function (modal, p, pr, data) {
    var rec = recommend(pr, p, data);
    if (!rec) return false;
    var name = p.model.charAt(0) + p.model.slice(1).toLowerCase();
    modal.querySelector('[data-cw-fit-for]').textContent = T('result_for', { model: name });
    modal.querySelector('[data-cw-fit-size]').textContent = rec.size.name;
    var st = modal.querySelector('[data-cw-fit-status]');
    st.textContent = statusOf(rec);
    st.className = 'cw-fit__status' + (rec.alt ? ' is-between' : '') + (rec.tooBig || rec.tooSmall ? ' is-out' : '');
    modal.querySelector('[data-cw-fit-reasons]').innerHTML = reasonsHtml(rec, pr, p);
    var ch = modal.querySelector('[data-cw-fit-choose]');
    ch.textContent = T('choose', { size: rec.size.name });
    ch.setAttribute('data-size', rec.size.name);
    showStep(modal, 'result');
    return true;
  };

  var selectSize = function (name) {
    var inputs = document.querySelectorAll('variant-selects input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === name) {
        if (!inputs[i].checked) inputs[i].click();
        return;
      }
    }
  };

  var renderHint = function () {
    var hint = document.querySelector('[data-cw-fit-hint]');
    var p = readProduct();
    var pr = getProfile();
    if (!hint || !p || !pr) return;
    loadData(p).then(function (data) {
      var rec = recommend(pr, p, data);
      if (!rec) return;
      var name = p.model.charAt(0) + p.model.slice(1).toLowerCase();
      var hv = { model: esc(name), size: '<strong>' + esc(rec.size.name) + '</strong>' };
      hint.innerHTML = T(rec.tooBig ? 'hint_big' : 'hint', hv) +
        (rec.alt ? ' <span class="cw-fit__hint-alt">' + T('hint_alt', { size: esc(rec.alt.name) }) + '</span>' : '') +
        ' <button type="button" class="cw-fit__hint-more" data-cw-fit-open>' + T('why') + '</button>';
      hint.hidden = false;
      var prompt = document.querySelector('[data-cw-fit-prompt]');
      if (prompt) prompt.hidden = true;
      /* akordeon „Rozmiar i dopasowanie": ten sam wynik + „Zobacz szczegóły" */
      var accText = document.querySelector('[data-cw-fit-acc-text]');
      var accBtn = document.querySelector('[data-cw-fit-acc-btn]');
      if (accText) accText.innerHTML = T(rec.tooBig ? 'hint_big' : 'hint', hv);
      if (accBtn) accBtn.textContent = T('details');
    });
  };

  var open = function (trigger) {
    var p = readProduct();
    if (!p) return;
    lastTrigger = trigger || null;
    var modal = buildModal();
    var pr = getProfile();
    var name = p.model.charAt(0) + p.model.slice(1).toLowerCase();
    modal.querySelector('[data-cw-fit-intro]').textContent = T('intro', { model: name });
    fillForm(modal, pr);
    modal.querySelector('[data-cw-fit-error]').hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('cw-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    loadData(p).then(function (data) {
      var shown = pr && renderResult(modal, p, pr, data);
      if (!shown) showStep(modal, 'form');
      var focus = modal.querySelector(shown ? '[data-cw-fit-choose]' : '[name="height"]');
      if (focus) focus.focus({ preventScroll: true });
    });
  };

  var close = function () {
    var modal = document.querySelector('[data-cw-fit-modal]');
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('cw-modal-open');
    setTimeout(function () { modal.hidden = true; }, 250);
    /* focus wraca z opóźnieniem: przy Esc keyup trafiłby już w przycisk
       w akordeonie i Dawnowy onKeyUpEscape zwijał „Rozmiar i dopasowanie" */
    var back = lastTrigger;
    setTimeout(function () {
      if (back && document.contains(back)) back.focus({ preventScroll: true });
    }, 200);
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cw-fit-open]')) {
      e.preventDefault();
      open(t.closest('[data-cw-fit-open]'));
      return;
    }
    if (t.closest('[data-cw-fit-close]')) {
      close();
      return;
    }
    if (t.closest('[data-cw-fit-edit]')) {
      var modal = document.querySelector('[data-cw-fit-modal]');
      showStep(modal, 'form');
      var h = modal.querySelector('[name="height"]');
      if (h) h.focus({ preventScroll: true });
      return;
    }
    if (t.closest('[data-cw-fit-guide-edit]')) {
      var gbox = document.querySelector('[data-cw-fit-guide-result]');
      var gform = document.querySelector('[data-cw-fit-guide] .cw-fit__form');
      if (gbox) gbox.hidden = true;
      if (gform) {
        gform.hidden = false;
        var gh = gform.querySelector('[name="height"]');
        if (gh) gh.focus({ preventScroll: true });
      }
      return;
    }
    var ch = t.closest('[data-cw-fit-choose]');
    if (ch) {
      selectSize(ch.getAttribute('data-size'));
      close();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.cw-fit__form');
    if (!form) return;
    e.preventDefault();
    var num = function (k, min, max) {
      var v = Math.round(+form.querySelector('[name="' + k + '"]').value);
      return v >= min && v <= max ? v : null;
    };
    var pr = {
      height: num('height', 140, 200),
      bust: num('bust', 70, 130),
      waist: num('waist', 50, 120),
      hips: num('hips', 80, 140),
      pref: (form.querySelector('[name="pref"]:checked') || {}).value || 'std',
      at: Date.now(),
    };
    var err = form.querySelector('[data-cw-fit-error]');
    if (!pr.bust && !pr.hips) {
      err.hidden = false;
      return;
    }
    err.hidden = true;
    saveProfile(pr);
    if (form.closest('[data-cw-fit-guide]')) {
      renderGuide(pr);
      return;
    }
    var p = readProduct();
    var modal = document.querySelector('[data-cw-fit-modal]');
    loadData(p).then(function (data) {
      renderResult(modal, p, pr, data);
      var c = modal.querySelector('[data-cw-fit-choose]');
      if (c) c.focus({ preventScroll: true });
      renderHint();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* variant-selects jest podmieniany po każdej zmianie wariantu — podpowiedź
     trzeba odtworzyć na nowym elemencie */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var hint = document.querySelector('[data-cw-fit-hint]');
      if (hint && hint.hidden && getProfile()) renderHint();
    });
  }).observe(document.body, { childList: true, subtree: true });

  renderHint();
  initGuide();
})();
